import { render, staticRenderFns } from "./DocumentCard.vue?vue&type=template&id=47e38c54&"
import script from "./DocumentCard.vue?vue&type=script&lang=js&"
export * from "./DocumentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports